import { ApiErrorResponse } from "../types/error";

export const getRtkErrorMessage = (error: unknown): string => {
    const err = error as ApiErrorResponse;
    return err?.message;
};